import React from 'react'
import {willUseSharedCallback} from '@startlibs/core'

export const [useRegisterCaseUpdate,triggerCaseUpdate] = willUseSharedCallback()
export const [useRegisterCasesUpdate,triggerCasesUpdate] = willUseSharedCallback()
